/** The set lifecycle. Mirrors public.is_question_set_status_transition_allowed. */
export enum QuestionSetStatus {
  Draft = 'draft',
  Published = 'published',
  Archived = 'archived',
}

/** How the candidates are drawn. One value so far; the blueprint records it all the same. */
export enum QuestionSetDistribution {
  Random = 'random',
}

/** What a blueprint does with a question already used in a published set. */
export enum QuestionSetPreviouslyUsed {
  Include = 'include',
}
